import { useState, useEffect, createContext } from 'react'

import { useNavigate } from 'react-router-dom'
import { useCustomAxios } from '../../axiosInstance'
import Step1 from './Step1'
import ResetPassword from './ResetPassword'
import Otp from './Otp'
import NewPassword from './NewPassword'
import Details from './Details'
import { toastError, toastSuccess } from '../../util/toastUtil'
import Loader from '../../components/Loader/loader'
import './forgotPasswordForTmdsas.css'
import { RESETPASSWORD_ENDPOINTS } from '../../constants/apiConstants'
import logo from '../../assets/Images/TMDSAS_Logo_2020.png'

const STEP = {
    step1: 'step1',
    step2: 'step2',
    step3: 'step3',
    step4: 'step4',
}
export const ResetPasswordContext = createContext()
const ForgotPasswordForTmdsas = () => {
    const axios = useCustomAxios()
    const navigate = useNavigate()
    const [step, setCurrentStep] = useState(STEP.step1)
    const [loadingData, setLoadingData] = useState(false)

    const [contextData, setContextData] = useState()

    useEffect(() => {
        return () => {
            // This is the cleanup function that will be executed when the component unmounts.
            sessionStorage.clear()
        }
    }, [])

    const handleOtp = async (contextData) => {
        try {
            const { userDetails, selectedOption, phoneNumber } = contextData
            const { email, userId, roleId } = userDetails

            const options = {
                headers: { 'content-type': 'application/json' },
            }

            const isPhoneNumberOption = selectedOption === 'phone_number'
            const url = isPhoneNumberOption
                ? RESETPASSWORD_ENDPOINTS.REQUESTTELESIGNOTP
                : RESETPASSWORD_ENDPOINTS.REQUESTEMAILOTP
            const data = {
                email,
                roleId,
                userId,
                ...(isPhoneNumberOption && { phoneNumber }),
            }

            setLoadingData(true)
            const response = await axios.post(url, data, options)

            if (response) {
                setLoadingData(false)
                if (isPhoneNumberOption) {
                    const responseBody = JSON.parse(response.data.body)
                    // console.log(responseBody);
                    // console.log(response);
                    if (response.data.statusCode !== 200) {
                        toastError(responseBody.errors[0].description)
                        return
                    }
                    setContextData((prevContext) => ({
                        ...prevContext,
                        otpNumberDetails: responseBody,
                    }))
                    toastSuccess('OTP sent successfully to your mobile number')
                    setCurrentStep(STEP.step3)
                } else {
                    setContextData((prevContext) => ({
                        ...prevContext,
                        otpEmailDetails: response.data,
                    }))
                    toastSuccess('OTP sent successfully to your email')
                    setCurrentStep(STEP.step3)
                }
            }
        } catch (error) {
            // console.error('An error occurred:', error)
            setLoadingData(false)
            toastError(
                error.response.data
                    ? error.response.data
                    : 'Something went wrong, please try again.'
            )
        }
    }

    const getView = () => {
        switch (step) {
            case STEP.step1:
                return (
                    <Step1
                        setCurrentStep={setCurrentStep}
                        STEP={STEP}
                        setLoadingData={setLoadingData}
                    />
                )
            case STEP.step2:
                return (
                    <ResetPassword
                        setCurrentStep={setCurrentStep}
                        STEP={STEP}
                        handleOtp={handleOtp}
                        setLoadingData={setLoadingData}
                    />
                )
            case STEP.step3:
                return (
                    <Otp
                        setCurrentStep={setCurrentStep}
                        STEP={STEP}
                        handleOtp={handleOtp}
                        setLoadingData={setLoadingData}
                    />
                )
            case STEP.step4:
                return (
                    <NewPassword
                        setCurrentStep={setCurrentStep}
                        STEP={STEP}
                        setLoadingData={setLoadingData}
                    />
                )
        }
    }
    return (
        <ResetPasswordContext.Provider value={[contextData, setContextData]}>
            <Loader open={loadingData} />
            <nav className="auth-navbar-forgot-password-tmdsas-container">
                <a
                    style={{ maxWidth: '10%' }}
                    className="auth-nav-bar-forgot-password-tmdsas-icon-container"
                    onClick={() => window.open('https://tmdsas.com', '_blank')}>
                    <img src={logo} height={75} />
                </a>
                <section
                    className="section"
                    style={{
                        padding: '0px',
                        display: 'flex',
                        justifyContent: 'center',
                    }}>
                    {getView()}
                </section>
                <Details />
            </nav>
        </ResetPasswordContext.Provider>
    )
}
export default ForgotPasswordForTmdsas
